import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import { RotateCw } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState, useMemo, useTransition } from "react";
import CommonHeading from "../../components/commonComponents/commonHeading";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import { useNavigate } from "react-router-dom";
import { getRegisterdInvestors, initialResetState } from "../../redux/slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { DialogActions, DialogContentText } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  editandDeleteProfile,
  updateProfileName,
} from "../../redux/slice/userSlice";
// import { FetchProfileList } from "../../redux/slice/PurchaseProfileList";
import moment from "moment";
import Loading from "../../components/Loading";
import { AppDispatch } from "../../redux/types";
import { Helmet } from "react-helmet";
import { getKycDetails } from "../../redux/slice/ledgerSlice";
import ConfirmationDialog from "../../components/commonComponents/DialogComponents";
import { useMsal } from "@azure/msal-react";
import { businessNameVerification } from "@/components/KYB/IdentityVerfication/DocumentList";
interface PurchaseProfileData {
  profileName: string;
  profileType: string;
  buyerName: string;
  profileStatus: string;
  lastVerifiedOn: string;
  IsDefault?: boolean;
}

interface ProfileDetailsProps {
  id: string;
  ProfileName: string;
  profileType: string;
  legalBusinessName: string;
  category: string;
  subCategory: string;
  businessEIN: string;
  businessAddress: any;
  address: any,
  administrator: {
    firstName: string;
    lastName: string;
    address: string;
    email: string;
    phone: string;
  };
  controllingOfficer: {
    firstName: string;
    lastName: string;
    address: string;
    email: string;
    phone: string;
  };
  beneficialOwner: {
    firstName: string;
    lastName: string;
    address: string;
    email: string;
    phone: string;
    percentOwnership: string;
  }[];
}

const RefreshButton = ({ isLoading = false, onClick }) => {
  return (
    <span
      className="text-[#FF5C39] font-[500] text-[14px] cursor-pointer mt-2 inline-flex items-center"
      onClick={onClick}
    >
      <RotateCw
        size={24}
        style={isLoading ? {
          animation: 'spin-clockwise 1s linear infinite'
        } : {}}
      />
    </span>
  );
};

function getInvestorStatus(investor: any) {
  const {
    VerificationStatus,
    KycAction,
    IsSilaRegistered,
    AccountStatus,
    BusinessChildAccounts = [],
  } = investor;

  // Helper function to check if any child account has specific kyc_action
  const hasChildWithKycAction = (action: any) => {
    return BusinessChildAccounts.some((child: any) => child.KycAction === action);
  };

  const hasChildWithIsSilaRegisteredFalse = () => {
    return BusinessChildAccounts.some((child: any) => child.IsSilaRegistered === false);
  };

  // Helper function to check if all child accounts have null KycAction
  const allChildrenHaveNullKycAction = () => {
    return BusinessChildAccounts.every((child: any) => child.KycAction === null);
  };

  if (KycAction === "inprogress_nonsila") {
    return "In progress";
  }

  // Condition: AccountStatus == 'INACTIVE' and kyc_action null (including BusinessChildAccounts)
  if (
    VerificationStatus
    ==
    "failed"
  ) {
    return "Failed";
  }

  if (VerificationStatus == "documents_received") {
    return "In progress";
  }

  if (VerificationStatus == 'pending' || VerificationStatus == "member_pending") {
    return "In progress";
  }

  if (KycAction === "doc_upload" || hasChildWithKycAction("doc_upload")) {
    return "Documents Required";
  }

  // Condition: VerificationStatus == 'documents_required' and kyc_action == 'entity_data'
  if (
    VerificationStatus == "documents_required" &&
    KycAction === "entity_data"
  ) {
    return "Documents Required";
  }
  const hasEntityData = KycAction === "entity_data" || hasChildWithKycAction("entity_data");

  if (hasEntityData) {

    return "Documents Required";
  }

  if (IsSilaRegistered === false || hasChildWithIsSilaRegisteredFalse()) {
    return "Update Info";
  }
  // Condition: VerificationStatus == 'documents_required' and kyc_action == 'doc_upload'
  if (
    VerificationStatus == "documents_required" &&
    KycAction === "doc_upload"
  ) {
    return "Documents Required";
  }

  if (VerificationStatus === "member_failed") {
    // Check if any child account has kyc_action as 'Failed'
    return "Failed";
  }

  if (KycAction === "review") {
    return "In progress";
  }

  if (VerificationStatus == "documents_required" && KycAction === "review") {
    return "In progress";
  }



  // Condition: VerificationStatus == 'member_review'
  if (VerificationStatus == "member_review") {
    // Check if any child account has doc_upload
    if (hasChildWithKycAction("doc_upload")) {
      return "Documents Required";
    }

    if (KycAction == null) {
      return "In progress";
    }

    // Condition: IsSilaRegistered == false

  }
  return "In progress";
}

// Helper to get a specific business role from accounts
function getBusinessRole(accounts: any[], role: string) {
  return accounts?.find((child: any) => child.BusinessUserType === role) || {};
}

// Helper to get all beneficial owners
function getBeneficialOwners(accounts: any[]) {
  return accounts?.filter((child: any) => child.BusinessUserType === "beneficial_owner") || [];
}

// Helper to get profile name
function getProfileName(profile: any) {
  if (profile.ProfileName?.length > 2) return profile.ProfileName;
  if (profile.profileName?.length > 2) return profile.profileName;
  if (profile.BusinessDetailsResponse?.BusinessName) return profile.BusinessDetailsResponse.BusinessName;
  if (profile.firstName && profile.lastName) return `${profile.firstName} ${profile.lastName}`;
  return "";
}

// Helper to get business address as string
function getBusinessAddress(profile: any, stateName: string) {
  return [
    profile.deliveryLine || profile.DeliveryLine,
    profile.deliveryLine2 || profile.DeliveryLine2,
    profile.city || profile.City,
    stateName,
    profile.country || profile.Country,
    (profile.ZipCode || profile.zipCode)?.replace('-0000', '')
  ].filter(Boolean).join(', ');
}

export const PurchaseProfile = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedProfiledefault, setSelectedProfiledefault] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState<keyof PurchaseProfileData | null>(
    null
  );
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] =
    useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingDialog, setLoadingDialog] = useState(false);
  const navigate = useNavigate();
  const [isPending, startTransition] = useTransition();
  const [stateName, setStateName] = useState('')
  const dispatch = useDispatch<AppDispatch>();
  const [kycResponses, setKycResponses] = useState([]);
  const [registeredInvestors, setRegisteredInvestors] = useState([]);
  const [profileLoadingStatus, setProfileLoadingStatus] = useState<{ [key: string]: boolean }>({});
  const { instance } = useMsal();
  const SignupEmail: any = instance?.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail');
  // Create a stable selector using useMemo instead of useCallback
  const userSelector = React.useMemo(() => (state: any) => state.user, []);
  const { userData, investorId, loginUserDetails, loading: investorLoading } = useSelector(userSelector);
  const { states } = useSelector((state: any) => state.stateCounty);
  const kyb = useSelector((state: any) => state.kyb);
  // Function to process inactive profiles and fetch KYC details
  const processInactiveProfiles = async (profiles: any[], dispatch: any) => {
    const inactiveProfiles = profiles.filter(
      (profile: any) => profile.AccountStatus === "INACTIVE" && profile.InvestorId
    );

  };


  const handleNavigateToDocumentRequired = async (investorId: string, profile: any) => {
    const navigatation = getInvestorStatus(profile);
    if (typeof navigatation === "object" || navigatation === "Update Info") {
      navigate(`/purchaseprofile/identity-verification/${investorId}`)
    } else if (navigatation == "Documents Required") {
      navigate(`/purchaseprofile/additional-document-required/${investorId}`, { state: { profile } });
    }
  }

  useEffect(() => {
    dispatch(initialResetState())
  }, [])

  const handleRegistation = async () => {
    const isImpersonating = sessionStorage.getItem("isImpersonate")
    if (loginUserDetails) {
      const mail = isImpersonating === "true" ? loginUserDetails?.Email : SignupEmail
      const { response } = await dispatch(getRegisterdInvestors(mail)).unwrap();
      if (response?.PurchaseProfile?.length > 0) {
        await processInactiveProfiles(response.PurchaseProfile, dispatch);
      }
      setLoading(false);
    }
  };


  useEffect(() => {
    setLoading(true);
    // handleRegistation();
    const tempState = states.filter((ele: any) => ele.value === userData.state)
    setStateName(tempState[0]?.label)
  }, [loginUserDetails]);

  useEffect(() => {
    // if(userData?.purchaseProfile?.length === 0){
    handleRegistation();
    // }
  }, [])


  const handleSort = (field: keyof PurchaseProfileData) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };
  const handleNavigate = () => {
    startTransition(() => {
      navigate("/purchaseprofile/identity-verification");
    });
  };

  const handleSetDefault = async (purchaseProfileId: number) => {
    setLoading(true);
    const payload: any = {
      ParentInvestorId: investorId,
      PurchaseProfileId: purchaseProfileId,
      IsDefault: true,
      IsDeleted: false,
    };
    await dispatch(editandDeleteProfile(payload));
    await dispatch(getRegisterdInvestors(SignupEmail));
    setLoading(false);
  };

  const handleDelete = async (purchaseProfileId: number) => {
    setLoading(true);
    const payload = {
      ParentInvestorId: investorId,
      PurchaseProfileId: purchaseProfileId,
      IsDefault: false,
      IsDeleted: true,
    };
    await dispatch(editandDeleteProfile(payload)).unwrap();
    await dispatch(getRegisterdInvestors(userData.email)).unwrap();
    setLoading(false);
  };

  const isDocumentRequired = true;


  const onRefreshKycCheck = async (profile: any) => {
    // Set loading state for this specific profile
    setProfileLoadingStatus(prevStatus => ({
      ...prevStatus,
      [profile.InvestorId]: true,
    }));
    try {
      await dispatch(getKycDetails(profile.InvestorId)).unwrap()
      await dispatch(getRegisterdInvestors(userData.email)).unwrap();
    } catch (error) {
      console.error("Error refreshing profile status:", error);
      // Handle error if necessary
    } finally {
      // Set loading state for this specific profile to false
      setProfileLoadingStatus(prevStatus => ({
        ...prevStatus,
        [profile.InvestorId]: false,
      }));
    }
  }


  // Now you can map over `tableData` to render the table rows dynamically

  const handleProfileClick = (profile: any) => {
    // Find the business account and its child accounts
    const businessAccount = profile?.BusinessChildAccounts?.length > 0 ? profile : profile?.BusinessAccounts?.length > 0 ? profile : null;
    if (businessAccount) {
      const administrator = (businessAccount.BusinessChildAccounts || businessAccount.BusinessAccounts)?.find(
        (child: any) => child.BusinessUserType === "administrator"
      );
      const controllingOfficer = (businessAccount.BusinessChildAccounts || businessAccount.BusinessAccounts)?.find(
        (child: any) => child.BusinessUserType === "controlling_officer"
      );
      const beneficialOwners = (businessAccount.BusinessChildAccounts || businessAccount.BusinessAccounts)?.filter(
        (child: any) => child.BusinessUserType === "beneficial_owner"
      );
      setSelectedProfile({
        id: businessAccount.InvestorId || businessAccount?.investorId || businessAccount?.BusinessDetailsResponse?.InvestorId,
        ProfileName: businessAccount.ProfileName?.length > 2 ? businessAccount?.profileName || businessAccount.ProfileName : businessAccount.BusinessDetailsResponse?.BusinessName,
        profileType: businessAccount.UserType || businessAccount.userType,
        legalBusinessName: businessAccount?.BusinessDetailsResponse?.BusinessName,
        category: businessAccount?.BusinessDetailsResponse?.Category,
        subCategory: businessAccount?.BusinessDetailsResponse?.Subcategory,
        businessEIN: "N/A",
        businessAddress: businessAccount.DeliveryLine || businessAccount?.deliveryLine,
        administrator: {
          firstName: administrator?.FirstName || "",
          lastName: administrator?.LastName || "",
          address: administrator?.DeliveryLine || "",
          email: administrator?.Email || "",
          phone: administrator?.Phone || "",
        },
        controllingOfficer: {
          firstName: controllingOfficer?.FirstName || "",
          lastName: controllingOfficer?.LastName || "",
          address: controllingOfficer?.DeliveryLine || "",
          email: controllingOfficer?.Email || "",
          phone: controllingOfficer?.Phone || "",
        },
        beneficialOwner:
          beneficialOwners?.map((owner: any) => ({
            firstName: owner.FirstName,
            lastName: owner.LastName,
            address: owner.DeliveryLine,
            email: owner.Email,
            phone: owner.Phone,
            percentOwnership: "25", // Default value since it's not in the API response
          })) || [],
      });
      setIsProfileModalOpen(true);
    } else {
      setSelectedProfile({
        id: profile.investorId,
        ProfileName: (profile.ProfileName?.length > 2 || profile.profileName?.length > 2) ? profile.ProfileName || profile.profileName : profile.BusinessDetailsResponse?.BusinessName || profile?.firstName + " " + profile?.lastName,
        profileType: profile.UserType || profile?.userType,
        legalBusinessName: profile?.BusinessDetailsResponse?.BusinessName,
        category: profile?.BusinessDetailsResponse?.Category,
        subCategory: profile?.BusinessDetailsResponse?.Subcategory,
        businessEIN: "N/A",
        address: `${profile.deliveryLine} ${profile.deliveryLine2 !== "" && profile.deliveryLine2 + ","} ${profile.city}, ${stateName} ${profile.country} ${profile?.ZipCode?.replace('-0000', '') || profile?.zipCode?.replace('-0000', '')}`,
        businessAddress: [
          profile.deliveryLine || profile.DeliveryLine,
          profile.deliveryLine2 || profile.DeliveryLine2,
          profile.city || profile?.City, stateName, profile.country || profile?.Country, profile?.ZipCode?.replace('-0000', '')
        ]
          .filter(Boolean)  // Removes falsy values
          .join(', '),
      });
      setIsProfileModalOpen(true);
    }
  };

  interface KycResponse {
    body: Array<{
      verification_id: string;
      kyc_action: string;
    }>;
  }

  const handleCloseModal = async () => {
    setHaschanged(false)
    setIsProfileModalOpen(false);
    setSelectedProfile(null);
    setIsEditingName(false);
    setLoadingDialog(false)
  };

  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [originalName, setOriginalName] = useState("");
  const [hasChangesd, setHaschanged] = useState(false)


  // Check if there are changes to the username
  const hasChanges = editedName !== originalName;

  const handleUpdateProfileName = async () => {
    setLoadingDialog(true)
    try {
      // setLoading()
      if (selectedProfile && editedName.trim() && hasChanges) {
        await dispatch(
          updateProfileName({
            investorId: selectedProfile.id,
            profileName: editedName.trim(),
          })
        ).unwrap();
        setIsEditingName(false);
        setOriginalName(editedName.trim());
        // Refresh the profile data
        await dispatch(getRegisterdInvestors(SignupEmail)).unwrap();
      }
    } catch (error) {
      setLoadingDialog(false)
      console.error("Failed to update profile name:", error);
    }
  };

  const renderProfileDetailsSection = (title: string, data: any) => (
    <div className="mb-6">
      <Typography className="font-[500] text-[16px] mb-4">{title}</Typography>
      {Object.entries(data)?.map(
        ([key, value]) =>
          key !== "percentOwnership" && (
            <div key={key} className="grid grid-cols-2 mb-2">
              <Typography className="text-[14px] text-gray-600">
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </Typography>
              <Typography className="text-[14px]">
                :&nbsp;&nbsp;{value as string}
              </Typography>
            </div>
          )
      )}
      {data.percentOwnership && (
        <div className="grid grid-cols-2 mb-2">
          <Typography className="text-[14px] text-gray-600">
            Percent Ownership of Business (50-100)
          </Typography>
          <Typography className="text-[14px]">
            :&nbsp;&nbsp;{data.percentOwnership}
          </Typography>
        </div>
      )}
    </div>
  );
  const handleCloseDialog = () => setDialogOpen(false);
  return (
    <>
      <Dialog disableEscapeKeyDown={true} open={dialogOpen} onClose={handleCloseDialog} aria-labelledby="confirmation-dialog" data-testid="confirmation-dialog" sx={{ zIndex: "999999" }}>
        <DialogContent sx={{ pt: "30px" }} data-testid="dialog-content">
          <Box display="flex" justifyContent="center" alignItems="center" mb={2} data-testid="error-icon-box">
            <ErrorOutlineIcon style={{ color: '#FF5C39' }} data-testid="error-icon" />
          </Box>
          <DialogContentText sx={{ textAlign: 'center', color: "#3b3b3b", fontSize: 16, fontWeight: 500 }} data-testid="dialog-text">
            {`Are you sure you want to delete this purchase profile - ${selectedProfiledefault?.ProfileName}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: "25px" }} data-testid="dialog-actions">
          <ButtonComponents
            label="Cancel"
            onClick={handleCloseDialog}
            variant="outlined"
            sx={{
              borderColor: '#FF5C39',
              color: '#FF5C39',
              '&:hover': { backgroundColor: '#ffe8e2' },
            }}
            data-testid="no-button"
          />
          <ButtonComponents
            label="Delete"
            onClick={() => {
              handleDelete(selectedProfiledefault?.InvestorId)
              handleCloseDialog()
            }}
            sx={{

              backgroundColor: '#FF5C39',
              color: '#fff',
              '&:hover': { backgroundColor: '#e65232' },
            }}
            data-testid="yes-button"
          />
        </DialogActions>
      </Dialog>

      <Helmet>
        <title>{`xBid | Purchase Profile`}</title>
        <meta name="description" content={`Purchase profile`} />
      </Helmet>
      {loading || kyb?.loading || (investorLoading && !profileLoadingStatus) ? (
        <Loading height={"100vh"} />
      ) : (
        <Box className="p-2 bg-[#f8f8f8] md:pr-12 pr-0">
          <Box className="flex justify-between flex-row items-center mb-6" sx={{ mt: { sm: 3, md: 0, xs: 0 } }}>
            <div>
              <CommonHeading sx={{ mb: 2, fontWeight: "600", fontSize: 22, mt: { sm: "20px", md: "0px", xs: "2px" } }} heading={"Purchase Profiles"} />
            </div>

            <Box
              display={"flex"}
              mt={{ xs: 2, md: 0 }}
              justifyContent={{ xs: "center", md: "end" }}
            >
              <ButtonComponents
                sx={{ px: { xs: 1, sm: 3 }, mr: 0, fontSize: { sm: "16px", xs: "12px" }, mb: 0 }}
                label={"Add New Purchase Profile"}
                onClick={handleNavigate}
                datatestid="Purchase profile"
              />
            </Box>
          </Box>
          <div className="bg-white rounded-lg shadow" data-testid="purchase-profiles-table">
            <div className="flex justify-end items-center px-6 py-3 border-t">
              <div className="flex items-center">
                <span className="text-[500] text-[13px] sm:text-[14px] md:text-[16px] text-[#838383]">
                  Rows per page{" "}
                </span>
                <select
                  data-testid="rows-per-page-select"
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  className="ml-2 border rounded-md md:px-3 px-1 md:py-3 py-1 text-[15px] font-[500] text-[#838383]"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
            <div className="overflow-x-auto w-[98%] mx-auto">
              <table role="presentation" className="min-w-full mx-auto ">
                <thead>
                  <tr className="border p-2">
                    {[
                      { key: "profileName", label: "Profile Name" },
                      { key: "profileType", label: "Profile Type" },
                      { key: "buyerName", label: "Buyer Name" },
                      { key: "profileStatus", label: "Profile Status" },
                      { key: "lastVerifiedOn", label: "Last Verified On" },
                    ]?.map(({ key, label }) => (
                      <th
                        data-testid={`column-header-${key}`}
                        key={key}
                        style={{ textWrap: "nowrap" }}
                        onClick={() =>
                          handleSort(key as keyof PurchaseProfileData)
                        }
                        className="px-12 py-3 text-left text-[16px] font-[500] text-gray-600 cursor-pointer group"
                      >
                        <div className="flex items-center">
                          <div className="font-[500] text-[16px]">{label}</div>
                          <span className="ml-2 inline-block">
                            {sortField === key ? (
                              <div className="flex flex-col"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginLeft: "4px",
                                  position: "relative"
                                }}>
                                <svg
                                  style={{
                                    position: "absolute",
                                    top: "-11px",
                                    marginBottom: 0, // Remove bottom margin to eliminate gap between icons
                                  }}
                                  className={`w-3 h-3 ml-[4px] mb-[2px] ${sortDirection === "asc"
                                    ? "text-[#3E4954]"
                                    : "text-gray-400"
                                    }`}
                                  fill="currentColor"
                                  viewBox="0 0 8 8"
                                >
                                  <path d="M0 6L4 2L8 6H0Z" />
                                </svg>
                                <svg
                                  style={{
                                    position: "absolute",
                                    bottom: "-11px",
                                  }}
                                  className={`w-3 h-3 ml-[4px] ${sortDirection === "desc"
                                    ? "text-[#3E4954]"
                                    : "text-gray-400"
                                    }`}
                                  fill="currentColor"
                                  viewBox="0 0 8 8"
                                >
                                  <path d="M0 2L4 6L8 2H0Z" />
                                </svg>
                              </div>
                            ) : (
                              <div className="flex flex-col opacity-50 group-hover:opacity-100" style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "4px",
                                position: "relative"
                              }}>
                                <svg
                                  className="w-3 h-3 ml-[4px] mb-[2px] text-gray-400"
                                  fill="currentColor"
                                  viewBox="0 0 8 8"
                                  style={{
                                    position: "absolute",
                                    top: "-11px",
                                    marginBottom: 0, // Remove bottom margin to eliminate gap between icons
                                  }}
                                >
                                  <path d="M0 6L4 2L8 6H0Z" />
                                </svg>
                                <svg
                                  style={{
                                    position: "absolute",
                                    bottom: "-11px",
                                  }}
                                  className="w-3 h-3 ml-[4px] text-gray-400"
                                  fill="currentColor"
                                  viewBox="0 0 8 8"
                                >
                                  <path d="M0 2L4 6L8 2H0Z" />
                                </svg>
                              </div>
                            )}
                          </span>
                        </div>
                      </th>
                    ))}
                    <th className="px-12 py-3 text-left text-[16px] font-[500] text-gray-600">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b hover:bg-gray-50" style={{ textWrap: "nowrap" }}>
                    <td className="px-12 py-4">
                      <span
                        data-testid="main-profile-name"
                        onClick={() => {
                          setEditedName(userData.profileName);
                          handleProfileClick({ ...userData, investorId })
                        }}
                        className="text-[#FF5C39] font-[500] text-[14px] underline cursor-pointer"
                      >
                        {userData?.profileName?.length > 2 ? userData?.profileName : userData?.BusinessDetailsResponse?.BusinessName || userData?.firstName + " " + userData?.lastName}
                      </span>
                      {userData && userData.IsDefault && (
                        <span
                          data-testid="main-profile-default-badge"
                          className="ml-2 text-xs text-[#FF5C39] font-[500] text-[14px] bg-[#FF5C3926] p-2 rounded-[20px]"
                        >
                          Default
                        </span>
                      )}
                    </td>
                    <td className="px-12 py-4 font-[500] text-[14px]">
                      {userData?.userType ? userData?.userType?.charAt(0)?.toUpperCase() + userData.userType?.slice(1) : ""}
                    </td>
                    <td className="px-12 py-4 font-[500] text-[14px]">
                      {userData?.BusinessDetailsResponse?.BusinessName?.length > 2 ? userData?.BusinessDetailsResponse?.BusinessName : userData?.profileName}
                    </td>
                    <td className="px-12 py-4 font-[500] text-[14px]">
                      <div className="flex items-center gap-8">
                        <span
                          data-testid="profile-status"
                          className="font-[500] text-[14px]"
                        >
                          {userData?.AccountStatus === "ACTIVE" ? (
                            <span className="font-[500] text-[14px]">
                              Verified
                            </span>
                          ) : isDocumentRequired ? (
                            <span className="text-[#FF5C39] font-[500] text-[14px] underline cursor-pointer">
                              Document Required
                            </span>
                          ) : (
                            <div className="flex">
                              <span className="text-[#FF5C39] font-[500] text-[14px]">
                                In progresss
                              </span>
                              <span className="text-[#FF5C39] font-[500] text-[14px] underline" >
                                Refresh
                              </span>
                            </div>
                          )}
                        </span>
                        {userData?.AccountStatus === "ACTIVE" && (
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#28A745"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-check-circle"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="M9 12l2 2 4-4"></path>
                            </svg>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="px-12 py-4 font-[500] text-[14px]">
                      {moment.utc(userData?.lastVerifiedOn)
                        .local()
                        .format("MMM D, YYYY, hh:mm A")}
                    </td>
                    <td className="px-12 py-4 font-[500] text-[14px]" >
                      <div className="flex items-center space-x-3">
                        {userData && !userData.IsDefault && (
                          <button
                            data-testid="main-profile-set-default"
                            onClick={() => handleSetDefault(investorId)}
                            aria-label="set as default"
                            className="flex items-center font-[500] text-[#FF5C39] text-[14px] hover:text-gray-900"
                          >
                            Set as Default
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                  {userData?.purchaseProfile?.map(
                    (profile: any, index: number) => (
                      <tr key={index} className="border-b hover:bg-gray-50" style={{ textWrap: "nowrap" }}>
                        <td className="px-12 py-4">
                          <span
                            data-testid={`purchase-profile-name-${index}`}
                            onClick={() => handleProfileClick(profile)}
                            className="text-[#FF5C39] font-[500] text-[14px] underline cursor-pointer"
                          >
                            {profile.ProfileName !== " " ? profile.ProfileName : profile?.BusinessDetailsResponse?.BusinessName}
                          </span>
                          {profile.IsDefault && (
                            <span
                              data-testid={`purchase-profile-default-badge-${index}`}
                              className="ml-2 text-xs text-[#FF5C39] font-[500] text-[14px] bg-[#FF5C3926] p-2 rounded-[20px]"
                            >
                              Default
                            </span>
                          )}
                        </td>
                        <td className="px-12 py-4 font-[500] text-[14px]">
                          {profile?.UserType ? profile?.UserType?.charAt(0)?.toUpperCase() + profile.UserType?.slice(1) : ""}
                        </td>
                        <td className="px-12 py-4 font-[500] text-[14px]">
                          {profile.ProfileName !== " " ? profile.ProfileName : profile?.BusinessDetailsResponse?.BusinessName}
                        </td>
                        <td className="px-12 py-4 font-[500] text-[14px]">
                          <div className="flex items-center gap-8">
                            <div
                              data-testid="business-profile-status"
                              className="font-[500] text-[14px] "
                            >
                              {profile.AccountStatus === "ACTIVE" ? (
                                <span className="font-[500] text-[14px]">
                                  Verified
                                </span>
                              ) : (
                                <div className="align-items-center flex items-center">
                                  {
                                    getInvestorStatus(profile) === "In progress" ? (
                                      <span className=" font-[500] text-[14px]">
                                        In progress
                                      </span>
                                    ) :
                                      <span className="text-[#FF5C39] font-[500] text-[14px] cursor-pointer" onClick={() => handleNavigateToDocumentRequired(profile.InvestorId, profile)}>
                                        {getInvestorStatus(profile) == "Documents Required" ? <div><span>Document <br />Required</span></div> : getInvestorStatus(profile)}
                                      </span>

                                  }
                                  {
                                    profile.VerificationStatus !== "failed" && (
                                      <span className="text-[#FF5C39] font-[500] text-[14px] ml-5 items-center" >
                                        <RefreshButton isLoading={profileLoadingStatus[profile.InvestorId] || false} onClick={() => onRefreshKycCheck(profile)} />
                                      </span>
                                    )
                                  }

                                </div>
                              )}
                            </div>
                            {profile.AccountStatus === "ACTIVE" && (
                              <div className="ml-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#28A745"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-check-circle"
                                >
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <path d="M9 12l2 2 4-4"></path>
                                </svg>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className={profile?.AccountStatus == "ACTIVE" ? "px-12 py-4 font-[500] text-[14px]" : "px-12 py-4 font-[500] text-[14px] text-center"} style={{ textWrap: "nowrap" }}>
                          {profile?.AccountStatus == "ACTIVE" ?
                            <>
                              {moment.utc
                                (`${profile.UpdatedAt}`).local()
                                .format("MMM D, YYYY, hh:mm A")}
                            </> :
                            <span className="text-center m-auto">-</span>
                          }

                        </td>
                        <td className="px-12 py-4 font-[500] text-[14px]" style={{ textWrap: "nowrap" }}>
                          {
                            profile?.AccountStatus == "ACTIVE" && (
                              <div className="flex items-center space-x-3">
                                {!profile?.IsDefault && (
                                  <button
                                    aria-label="set as default"
                                    onClick={() =>
                                      profile.AccountStatus === "ACTIVE" &&
                                      handleSetDefault(profile.InvestorId)
                                    }
                                    className={profile.AccountStatus === "ACTIVE" ? "text-[#FF5C39] underline cursor-pointer flex items-center font-[500] text-[14px] hover: hover:text-[#FF5C39]" : "flex items-center font-[500] text-[14px]  hover:text-[#FF5C39]"}
                                  >
                                    Set as Default
                                  </button>
                                )}
                                {!profile?.IsDefault && (
                                  <button
                                    aria-label="handle delete"
                                    onClick={() => {
                                      setDialogOpen(true)
                                      setSelectedProfiledefault(profile)
                                    }

                                    }
                                    className="text-gray-600 hover:text-red-600"
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      ></path>
                                    </svg>
                                  </button>
                                )}
                              </div>
                            )
                          }

                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Profile Details Modal */}
          <Dialog
            data-testid="profile-details-modal"
            open={isProfileModalOpen}
            sx={{
              zIndex: 99999
            }}
            onClose={handleCloseModal}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: "8px",
                padding: "24px",
                maxHeight: "90vh",
                overflowY: "hidden",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              },
            }}
          >
            {/* Fixed Header */}
            <div className="flex justify-between items-center mb-6">
              <Typography className="text-[20px] font-medium">
                Profile Details
              </Typography>
              <IconButton
                data-testid="modal-close-button"
                onClick={handleCloseModal}
                size="small"
                className="text-gray-500"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>

            {/* Scrollable Content */}
            <DialogContent
              sx={{
                p: 0,
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              }}
            >
              {loadingDialog ? <Loading height="180px" /> : selectedProfile && (
                <div className="space-y-6">
                  {/* Profile Details */}
                  <div className="space-y-4">
                    {Object.entries({
                      "Profile Name": (
                        <div className="flex items-center gap-2">
                          {isEditingName ? (
                            <div className="flex items-center gap-2">
                              <input
                                data-testid="profile-name-input"
                                style={{
                                  borderBottom: "1px solid #ccc",
                                  outline: "none",
                                  padding: "4px 0",
                                }}
                                value={editedName}
                                onChange={(e) => {
                                  setHaschanged(true)
                                  setEditedName(e.target.value)
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    handleUpdateProfileName();
                                  }
                                }}
                              />
                            </div>
                          ) : (
                            <>
                              {selectedProfile?.ProfileName !== ""
                                ? selectedProfile?.ProfileName
                                : selectedProfile?.BusinessDetailsResponse?.BusinessName}
                              <IconButton
                                data-testid="edit-profile-name-button"
                                size="small"
                                onClick={() => {
                                  setIsEditingName(true);
                                  setEditedName(selectedProfile.ProfileName);
                                  setOriginalName(selectedProfile.ProfileName);
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </>
                          )}
                        </div>
                      ),
                      "Profile Type": selectedProfile.profileType
                        ? selectedProfile.profileType.charAt(0).toUpperCase() + selectedProfile.profileType.slice(1)
                        : "",
                      ...(selectedProfile.profileType === "business" && {
                        "Legal Business Name": selectedProfile?.legalBusinessName,
                        "Business EIN": selectedProfile.businessEIN,
                      }),
                      ...(selectedProfile.profileType === "business" && selectedProfile.category && {
                        "Category": selectedProfile.category,
                      }),
                      ...(selectedProfile.profileType === "business" && selectedProfile.subCategory && {
                        "Sub-Category": selectedProfile.subCategory,
                      }),
                      ...(selectedProfile.profileType === "individual" && {
                        "Address": selectedProfile.address,
                      }),
                      ...(selectedProfile.profileType === "business" && {
                        "Business Address": selectedProfile.businessAddress,
                      }),
                    }).map(([label, value]) => (
                      <div key={label} className="flex items-start gap-x-8">
                        <Typography className="text-[14px] text-[#6B7280] w-[172px]">
                          {label}
                        </Typography>
                        <Typography className="text-[14px] text-[#111827] mx-6">:</Typography>
                        <Typography className="text-[14px] text-[#111827] flex-1 break-all whitespace-normal">
                          {/* @ts-ignore */}
                          {value}
                        </Typography>
                      </div>
                    ))}
                  </div>

                  <div className="border-b border-gray-200"></div>

                  {/* Administrator Information */}
                  {selectedProfile?.administrator?.firstName && (
                    <>
                      <Typography className="text-[16px] font-medium mb-4">
                        Administrator Information
                      </Typography>
                      <div className="space-y-4">
                        {Object.entries({
                          "First Name": selectedProfile.administrator.firstName,
                          "Last Name": selectedProfile.administrator.lastName,
                          Address: selectedProfile.administrator.address,
                          "Email Address": selectedProfile.administrator.email,
                          "Phone Number": selectedProfile.administrator.phone,
                        }).map(([label, value]) => (
                          <div key={label} className="flex items-start gap-x-8">
                            <Typography className="text-[14px] text-[#6B7280] w-[172px]">
                              {label}
                            </Typography>
                            <Typography className="text-[14px] text-[#111827] mx-6">
                              :
                            </Typography>
                            <Typography className="text-[14px] text-[#111827] flex-1 break-all whitespace-normal">
                              {/* @ts-ignore */}
                              {value}
                            </Typography>
                          </div>
                        ))}
                      </div>
                      <div className="border-b border-gray-200 mt-6"></div>
                    </>
                  )}

                  {/* Controlling Officer Information */}
                  {selectedProfile.controllingOfficer?.firstName && (
                    <>
                      <Typography className="text-[16px] font-medium mb-4">
                        Controlling Officer Information
                      </Typography>
                      <div className="space-y-4">
                        {Object.entries({
                          "First Name": selectedProfile.controllingOfficer.firstName,
                          "Last Name": selectedProfile.controllingOfficer.lastName,
                          Address: selectedProfile.controllingOfficer.address,
                          "Email Address": selectedProfile.controllingOfficer.email,
                          "Phone Number": selectedProfile.controllingOfficer.phone,
                        }).map(([label, value]) => (
                          <div key={label} className="flex items-start gap-x-8">
                            <Typography className="text-[14px] text-[#6B7280] w-[172px]">
                              {label}
                            </Typography>
                            <Typography className="text-[14px] text-[#111827] mx-6">
                              :
                            </Typography>
                            <Typography className="text-[14px] text-[#111827] flex-1 break-all whitespace-normal">
                              {value}
                            </Typography>
                          </div>
                        ))}
                      </div>
                      <div className="border-b border-gray-200 mt-6"></div>
                    </>
                  )}

                  {/* Beneficial Owner Information */}
                  {selectedProfile.beneficialOwner &&
                    selectedProfile.beneficialOwner.length > 0 && (
                      <>
                        <div className="flex justify-between items-center mb-4">
                          <Typography className="text-[16px] font-medium">
                            Beneficial Owner Information
                          </Typography>
                          {/* <Button
                            variant="text"
                            sx={{
                              color: "#FF5C39",
                              fontSize: "14px",
                              textTransform: "none",
                              padding: 0,
                              minWidth: "auto",
                              "&:hover": {
                                backgroundColor: "transparent",
                                textDecoration: "underline",
                              },
                            }}
                          >
                            Add another owner
                          </Button> */}
                        </div>
                        {selectedProfile.beneficialOwner.map((owner: any, index: number) => (
                          <div key={index} className="space-y-4">
                            {Object.entries({
                              "First Name": owner.firstName,
                              "Last Name": owner.lastName,
                              Address: owner.address,
                              "Email Address": owner.email,
                              "Phone Number": owner.phone,

                            }).map(([label, value]) => (
                              <div key={label} className="flex items-start gap-x-8">
                                <Typography className="text-[14px] text-[#6B7280] w-[172px]">
                                  {label}
                                </Typography>
                                <Typography className="text-[14px] text-[#111827]">
                                  :
                                </Typography>
                                <Typography className="text-[14px] text-[#111827] flex-1 break-all whitespace-normal">
                                  {value}
                                </Typography>
                              </div>
                            ))}
                          </div>
                        ))}
                      </>
                    )}
                </div>
              )}

            </DialogContent>

            {/* Footer Buttons */}
           
           {!loadingDialog && <> <hr /><div className="flex justify-end space-x-3 mt-6">
              <Button
                data-testid="modal-cancel-button"
                variant="outlined"
                onClick={handleCloseModal}
                sx={{
                  borderColor: "#D1D5DB",
                  color: "#374151",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#9CA3AF",
                    backgroundColor: "transparent",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                data-testid="modal-update-button"
                variant="contained"
                // disabled={!hasChangesd}
                onClick={async () => {
                  // Handle update
                  if (!hasChangesd) {
                    return
                  }
                  await handleUpdateProfileName();

                  await handleCloseModal();
                  setIsEditingName(false);
                }}

                sx={{
                  // backgroundColor: hasChangesd ? "#FF5C39" : "#ffffff",
                  cursor: !hasChangesd ? "default" : "pointer",
                  textTransform: "none",
                  backgroundColor:
                    !hasChangesd
                      ? "#9fa4ab"
                      : "#FF5C39",
                  color: "#fff",
                  border: !hasChangesd
                    ? "1px solid transparent"
                    : undefined,
                  boxShadow: !hasChangesd
                    ? "none" : undefined,
                  '&:hover': {
                    backgroundColor:
                      !hasChangesd
                        ? "#9fa4ab"
                        : "#e65232",
                    border: !hasChangesd
                      ? "1px solid transparent"
                      : undefined,
                    boxShadow: !hasChangesd
                      ? "none" : undefined,
                  },
                  // "&:disabled": {
                  //   backgroundColor: "#ffffff",
                  //   color: "#374151",
                  //   borderColor: "#D1D5DB",
                  // },
                }}
              >
                Update
              </Button>
            </div></>}
          </Dialog>
        </Box>
      )}
    </>

  );
};
